import React, { useEffect, useState } from "react";
import { Client } from "../../interfaces/client";
import { getClient } from "../../services/clientService";
import ReferenceForm from "../../components/questionnaires/ReferenceForm";
import CandidateForm from "../../components/questionnaires/CandidateForm";
import { useLocation, useParams } from "react-router-dom";

const EditQuestionnaires = () => {
  const location = useLocation();
  const { clientID } = useParams();
  const questionnaireType = location.state?.questionnaireType;
  const fiveYear = location.state?.fiveYear;
  const [client, setClient] = useState<Client | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClient = async () => {
      try {
        if (clientID) {
          const numericClientID = parseInt(clientID, 10);
          const client = await getClient(numericClientID);
          setClient(client);
        }
      } catch (error) {
        console.error("Error loading data:", error);
        setErrorMessage("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadClient();
  }, [clientID]);

  return (
    <>
      <div>
        <div className="content-container">
          <div className="header-container">
            <h1>
              {questionnaireType === "Reference" ? "Reference" : "Candidate"}{" "}
              Questionnaire
            </h1>
            <div className="page-items-container">
              <div className="field-long">
                <label className="field-label">Client Name:</label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    value={client?.clientName || ""}
                    disabled
                    readOnly
                  />
                </div>
              </div>
              <div className="field-long">
                <label className="field-label">Abbreviation:</label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    value={client?.abbreviation}
                    disabled
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="loading-divider">
              <div className="loading-bar"></div>
            </div>
          ) : (
            <>
              <div className="divider"></div>
              <div className="mt-3">
                {questionnaireType === "Reference" && (
                  <ReferenceForm isEditing={true} />
                )}
                {questionnaireType === "Candidate" && (
                  <CandidateForm
                    clientID={client?.clientID ? client?.clientID : 0}
                    orderFormID={0}
                    isReadOnly={true}
                    isEditing={true}
                    fiveYear={fiveYear}
                  />
                )}
              </div>
            </>
          )}
          {errorMessage && (
            <div
              className="alert-message alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              {errorMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setErrorMessage("")}
                aria-label="Close"
              ></button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EditQuestionnaires;
